import { useRouteMatch } from "react-router-dom";
import { FlowAddPaymentMethod } from "../../Settings/components/payment/FlowAddPaymentMethod";

import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const PaymentMethod: React.FC<FlowStep> = props => {
  const match = useRouteMatch();

  return <FlowAddPaymentMethod basePath={match.path} onNext={props.onNext} />;
};
